import { r as o, h as a, g as s } from "./main-bb89b2f2.js";
import "vue";
const l = "*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}.static{position:static}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}", n = l, h = class {
  constructor(e) {
    o(this, e), this.updateProps = () => {
      const t = this.queryListItems();
      if (t.length === 0)
        throw new Error("[patternlib-list] Must have at least one item");
      t.map((i) => {
        (i.itemHeight === "" || i.itemHeight === this.itemHeightOldValue) && (i.itemHeight = this.itemHeight), (i.labelWidth === "" || i.labelWidth === this.labelWidthOldValue) && (i.labelWidth = this.labelWidth), (i.noSeparator === void 0 || i.noSeparator === this.noSeparatorOldValue) && (i.noSeparator = this.noSeparator);
      });
      const r = this.queryListHead();
      r[0] && (r[0].labelWidth = this.labelWidth);
    }, this.itemHeight = "48px", this.labelWidth = "50%", this.noSeparator = void 0, this.width = "100%";
  }
  componentDidUpdate() {
    this.updateProps();
  }
  itemHeightWatcher(e, t) {
    typeof e == "string" && (this.itemHeightOldValue = t);
  }
  labelWidthWatcher(e, t) {
    typeof e == "string" && (this.labelWidthOldValue = t);
  }
  noSeparatorWatcher(e, t) {
    typeof e == "boolean" && (this.noSeparatorOldValue = t);
  }
  queryListItems() {
    var e;
    const t = this.hostElement.shadowRoot.querySelector("slot");
    return ((e = t == null ? void 0 : t.assignedNodes().filter((i) => i.nodeName === "PATTERNLIB-LIST-ITEM")) !== null && e !== void 0 ? e : []).map((i) => i);
  }
  queryListHead() {
    var e;
    const t = this.hostElement.shadowRoot.querySelector("slot");
    return (e = t == null ? void 0 : t.assignedNodes().filter((i) => i.nodeName === "PATTERNLIB-LIST-HEAD")) !== null && e !== void 0 ? e : null;
  }
  render() {
    return a("div", { key: "02f676aeb09f16cfa4cca2164373218a913f7303", style: { width: this.width } }, a("slot", { key: "02cbfae19dc9449b7d63d4ee582fc402fd34d4a1", onSlotchange: this.updateProps }));
  }
  get hostElement() {
    return s(this);
  }
  static get watchers() {
    return {
      itemHeight: ["itemHeightWatcher"],
      labelWidth: ["labelWidthWatcher"],
      noSeparator: ["noSeparatorWatcher"]
    };
  }
};
h.style = n;
export {
  h as patternlib_list
};
